<div class="audit-edit-container">
  <div class="audit-header">
    <div>
      <h1 class="page-title">Audit Detail</h1>
      <p class="page-subtitle">View detailed information about this audit log</p>
    </div>
    <app-button variant="secondary" (click)="goBack()">Back</app-button>
  </div>

  <div class="sections-container">
    <section class="user-section">
      <h2 class="section-title">User</h2>
      <div class="user-details">
        <div class="detail-row">
          <span class="detail-label font-monaco">ID:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.id || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Name:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.name || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Email:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.email || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Role:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.role?.name || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Phone:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.phone || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Address:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.address || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Image URL:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.user?.imageUrl || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Created At:</span>
          <span class="detail-value font-monaco"
            >{{ audit?.session?.user?.createdAt ? formatDate(audit?.session?.user?.createdAt) : "N/A" }}</span
          >
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Updated At:</span>
          <span class="detail-value font-monaco"
            >{{ audit?.session?.user?.updatedAt ? formatDate(audit?.session?.user?.updatedAt) : "N/A" }}</span
          >
        </div>
      </div>
    </section>

    <section class="audit-section">
      <h2 class="section-title">Request</h2>
      <div class="user-details">
        <div class="detail-row">
          <span class="detail-label font-monaco">ID:</span>
          <span class="detail-value font-monaco">{{ audit?.id || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Method:</span>
          <span class="detail-value font-monaco">{{ audit?.method || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">URL:</span>
          <span class="detail-value font-monaco">{{ audit?.url || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Created At:</span>
          <span class="detail-value font-monaco">{{ audit?.createdAt ? formatDate(audit?.createdAt) : "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Updated At:</span>
          <span class="detail-value font-monaco">{{ audit?.updatedAt ? formatDate(audit?.updatedAt) : "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Expire At:</span>
          <span class="detail-value font-monaco">{{ audit?.expireAt ? formatDate(audit?.expireAt) : "N/A" }}</span>
        </div>
      </div>
    </section>
  </div>

  <div class="sections-container">
    <section class="session-section">
      <h2 class="section-title">Session</h2>
      <div class="user-details">
        <div class="detail-row">
          <span class="detail-label font-monaco">ID:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.id || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">User Agent:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.userAgent || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">IP Address:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.ipAddress || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Access Token:</span>
          <span class="detail-value font-monaco">...{{ audit?.session?.accessToken?.slice(-60) || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Expire At:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.expireAt ? formatDate(audit?.session?.expireAt) : "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Created At:</span>
          <span class="detail-value font-monaco"
            >{{ audit?.session?.createdAt ? formatDate(audit?.session?.createdAt) : "N/A" }}</span
          >
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Updated At:</span>
          <span class="detail-value font-monaco"
            >{{ audit?.session?.updatedAt ? formatDate(audit?.session?.updatedAt) : "N/A" }}</span
          >
        </div>
      </div>
    </section>

    <section class="device-section">
      <h2 class="section-title">Device</h2>
      <div class="user-details">
        <div class="detail-row">
          <span class="detail-label font-monaco">Model:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.device?.model || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">OS:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.device?.os || "N/A" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label font-monaco">Browser:</span>
          <span class="detail-value font-monaco">{{ audit?.session?.device?.browser || "N/A" }}</span>
        </div>
      </div>
    </section>
  </div>

  <div class="sections-container">
    <section class="payload-section">
      <h2 class="section-title">Payload</h2>
      <div class="json-container font-monaco">
        <pre><code>{{ audit?.payload ? formatJson(audit?.payload) : "{}" }}</code></pre>
      </div>
    </section>

    <section class="response-section">
      <h2 class="section-title">Response</h2>
      <div class="json-container font-monaco">
        <pre><code>{{ audit?.response ? formatJson(audit?.response) : "{}" }}</code></pre>
      </div>
    </section>
  </div>
</div>
